import { render, staticRenderFns } from "./Locked.vue?vue&type=template&id=a07b9fe6"
import script from "./Locked.vue?vue&type=script&lang=js"
export * from "./Locked.vue?vue&type=script&lang=js"
import style0 from "./Locked.vue?vue&type=style&index=0&id=a07b9fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports